/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SearchResources200ResponseTablesInnerResource } from '../models/SearchResources200ResponseTablesInnerResource';
import { SearchResources200ResponseTablesInnerSnapshots } from '../models/SearchResources200ResponseTablesInnerSnapshots';
import { SearchResources200ResponseTablesInnerSource } from '../models/SearchResources200ResponseTablesInnerSource';
import { SearchResources200ResponseTablesInnerTablesInner } from '../models/SearchResources200ResponseTablesInnerTablesInner';

export class SearchResources200ResponseTablesInner {
  'resource'?: SearchResources200ResponseTablesInnerResource;
  'source'?: SearchResources200ResponseTablesInnerSource;
  'tables'?: Array<SearchResources200ResponseTablesInnerTablesInner>;
  'snapshots'?: SearchResources200ResponseTablesInnerSnapshots;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resource",
      "baseName": "resource",
      "type": "SearchResources200ResponseTablesInnerResource",
      "format": ""
    },
    {
      "name": "source",
      "baseName": "source",
      "type": "SearchResources200ResponseTablesInnerSource",
      "format": ""
    },
    {
      "name": "tables",
      "baseName": "tables",
      "type": "Array<SearchResources200ResponseTablesInnerTablesInner>",
      "format": ""
    },
    {
      "name": "snapshots",
      "baseName": "snapshots",
      "type": "SearchResources200ResponseTablesInnerSnapshots",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SearchResources200ResponseTablesInner.attributeTypeMap;
  }

  public constructor() {
  }
}

